import { z } from 'zod';

import { RefinedPasswordSchema, refineRepeatPassword } from './password.schema';

export const PasswordSignUpSchema = z
  .object({
    email: z.email(),
    password: RefinedPasswordSchema,
    repeatPassword: RefinedPasswordSchema,
    // UI-only: the Terms checkbox is bound to the form so the magic-link
    // secondary action can validate consent (the password submit also
    // enforces it via the checkbox's native `required`). Optional here so it
    // does not gate the zod parse; the component checks it explicitly.
    termsAccepted: z.boolean().optional(),
  })
  .superRefine((data, ctx) => {
    refineRepeatPassword(data, ctx);
  });
